module.exports = __webpack_public_path__ + "img/031-drawkit-phone-conversation-colour.8dae15fc.svg";